const projects =[
    {    id : 1,
        "name":"Keeper App",
        "description":"A Note keeping App made with React.JS",
        "repolink":"https://github.com/ayushkx/keeper-app",
        "deploylink":"https://cheerful-halva-8bbc98.netlify.app/"
    },
    {
        id : 2,
        "name":"SignUp Site",
        "description":"A SignUp site made using html , Css , Node.JS",
        "repolink":"https://github.com/ayushkx/newsletter_signup",
        "deploylink":"https://ancient-castle-99320.herokuapp.com/"
    },
    {
        id : 3,
        "name":"Real Estate",
        "description":"A Real Estate app made using React.js and Material UI",
        "repolink":"https://github.com/ayushkx/Real_estate-",
        "deploylink":"https://taupe-tanuki-d37e03.netlify.app/"
    },
    {
        id : 4,
        "name":"Textutils",
        "description":"A web App that can maniplulate your text, made with React.JS",
        "repolink":"https://github.com/ayushkx/textutils",
        "deploylink":"#"
    },
    {
        id : 5,
        "name":"Portfolio",
        "description":"My website made with React.JS",
        "repolink":"https://github.com/ayushkx/Portfolio",
        "deploylink":"https://famous-mandazi-60d575.netlify.app/"
    },
    {
        id : 6,
        "name":"Tic-tac-toe",
        "description":"Tic-tac-toe game made with python",
        "repolink":"https://github.com/ayushkx/tic-tac-toe",
        "deploylink":"#"
    }
]

export default projects;